import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { SubscriptionDTO } from "src/app/data/schema/Subscriptions/SubscriptionDTO";
import { ApiAchievementDetailsService } from "src/app/data/service/gamification/api-achievement-details.service";
import { AchievementPlayerDialogService } from "src/app/shared/component/achievement-player-dialog/achievement-player-dialog.service";
import { SubscriptionService } from "../subscription.service";

@Injectable({
    providedIn: "root"
})
export class AchievementMessageService {
    private subscription: SubscriptionDTO;

    constructor(
        private achDetailService: ApiAchievementDetailsService,
        private subscriptionService: SubscriptionService,
        private dialog: AchievementPlayerDialogService
    ) {
        this.subscriptionService.currentSubscriptionAsync().subscribe((sub) => (this.subscription = sub));
    }

    showAchievement(detailId: string): Observable<any> {
        if (!this.subscription?.features?.gamification) return;

        return this.achDetailService.Get(detailId).pipe(
            mergeMap((detail) => {
                return this.dialog.openDialog(detail);
            })
        );
    }
}
